import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import type * as models from '../../models'
import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.userForAssignment.DOC}
  query UsersForAssignment($ids: [ID!], $quantity: Int, $cursor: String) {
    users(ids: $ids, quantity: $quantity, cursor: $cursor) {
      items {
        ...FragmentUserForAssignment
      }
      nextCursor
    }
  }
`

// NOTE: Transforming only properties needed for assignment process
export const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.UsersForAssignmentQuery,
    ents.core.common.Response.For.Pagination<models.User>,
    'users'
  >(
    'users',
    graphql.transformers.OUT.object({
      items: graphql.transformers.OUT.default(
        graphql.transformers.OUT.list(fragments.userForAssignment.TRANSFORMER, {
          onNullish: 'remove',
        }),
        [],
      ),
      nextCursor: graphql.transformers.OUT.nullable(transformers.PASS_THROUGH),
    }),
  ),
  { items: [], nextCursor: undefined },
)

export const execute = graphql.createExecutor<
  graphql.schema.UsersForAssignmentQuery,
  ents.core.common.Response.For.Pagination<models.User>,
  graphql.schema.UsersForAssignmentQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
